export const createSelectOptions = (
  data: Record<string, unknown>[],
  property: string,
) => {
  const uniqueOptions = [...new Set(data.map((item) => item[property]))];
  uniqueOptions.sort();
  return uniqueOptions.map((option) => {
    // if (option === "-") {
    //   return {
    //     label: "No data",
    //     value: "No data",
    //   };
    // }
    return {
      label: option,
      value: option,
    };
  });
};

export const createSelectOptionsWithOrder = (
  data: Record<string, unknown>[],
  property: string,
  orderList: unknown[],
) => {
  let uniqueOptions = [...new Set(data.map((item) => item[property]))];

  // Filter out elements not found in the order array
  uniqueOptions = uniqueOptions.filter((option) => orderList.includes(option));

  // Sort the filtered uniqueOptions based on the order array
  uniqueOptions.sort((a, b) => {
    return orderList.indexOf(a) - orderList.indexOf(b);
  });

  return uniqueOptions.map((option) => {
    // if (option === "-") {
    //   return {
    //     label: "No data",
    //     value: "No data",
    //   };
    // }
    return {
      label: option,
      value: option,
    };
  });
};

export const getList = (data: Record<string, unknown>[], property: string) => {
  const uniqueOptions = [...new Set(data.map((item) => item[property]))];
  uniqueOptions.sort();
  return uniqueOptions;
};

export const getUnsortedList = (
  data: Record<string, unknown>[],
  property: string,
) => {
  const uniqueOptions = [...new Set(data.map((item) => item[property]))];
  return uniqueOptions;
};

export const getGroupArray = (
  data: Record<string, unknown>[],
  list: unknown[],
  property: string,
) => {
  if (!data || !list || !property) return [];
  const groupArray: Record<string, Record<string, unknown>[]>[] = [];
  for (let j = 0; j < list.length; j++) {
    const group: Record<string, unknown>[] = [];
    for (let i = 0; i < data.length; i++) {
      if (list[j] === data[i][property]) {
        group.push(data[i]);
      }
    }
    const groupObject: Record<string, Record<string, unknown>[]> = {};
    groupObject[String(list[j])] = group;
    groupArray.push(groupObject);
  }
  return groupArray;
};

export const getGroupArrayOrdered = (
  data: Record<string, unknown>[],
  list: unknown[],
  property: string,
  sortProperty: string,
) => {
  const groupArray: Record<string, Record<string, unknown>[]>[] = [];
  for (let j = 0; j < list.length; j++) {
    const group: Record<string, unknown>[] = [];
    for (let i = 0; i < data.length; i++) {
      if (list[j] === data[i][property]) {
        group.push(data[i]);
      }
    }

    // Sort the group alphabetically by sortProperty
    group.sort((a, b) =>
      (a[sortProperty] as string)?.localeCompare(b[sortProperty] as string),
    );

    const groupObject: Record<string, Record<string, unknown>[]> = {};
    groupObject[String(list[j])] = group;
    groupArray.push(groupObject);
  }
  return groupArray;
};

export const getGroupDataByPropertyAndSubproperty = (
  data: Record<string, unknown>[],
  list: unknown[],
  property: string,
  subproperty: string,
) => {
  const groupArray: Record<string, unknown[]>[] = [];
  for (let j = 0; j < list.length; j++) {
    const group: unknown[] = [];
    for (let i = 0; i < data.length; i++) {
      if (list[j] === data[i][property]) {
        group.push(data[i][subproperty]);
      }
    }
    const groupObject: Record<string, unknown[]> = {};
    const uniqueGroup = [...new Set(group)].sort();
    groupObject[String(list[j])] = uniqueGroup;
    groupArray.push(groupObject);
  }
  return groupArray;
};

export const getActivitiesOptions = (array: Record<string, string[]>[]) => {
  if (!Array.isArray(array) || array.length === 0) return [];
  const options: {
    label: JSX.Element | string;
    title?: string;
    value?: string;
    disabled?: boolean;
    options?: { label: JSX.Element; value: string; disabled: boolean }[];
  }[] = [];
  for (let i = 0; i < array.length; i++) {
    const key = Object.keys(array[i])[0];
    const item: {
      label: JSX.Element | string;
      title: string;
      options: { label: JSX.Element; value: string; disabled: boolean }[];
    } = {
      label: <span>{key}</span>,
      title: key,
      options: array[i][key].map((activity) => {
        return {
          label: <span>{activity}</span>,
          value: activity,
          disabled: false,
        };
      }),
    };
    options.push(item);
  }

  const allOption = {
    label: "ALL",
    value: "all",
    disabled: false,
  };
  options.unshift(allOption);

  return options;
};

//Function to Filter Table Data based on filters
export const getFilteredData = (
  data: Record<string, unknown>[],
  filters: Record<string, unknown[]>,
) => {
  let filteredData = data;

  Object.entries(filters).forEach(([property, filterValues]) => {
    if (filterValues.length > 0) {
      filteredData = filteredData.filter((item) =>
        filterValues.includes(item[property]),
      );
    }
  });
  return filteredData;
};

export function getValuesByProperty(
  data: Record<string, unknown>[],
  property: string,
) {
  let values: unknown[] = [];

  for (let i = 0; i < data.length; i++) {
    if (Object.keys(data[i])[0] === property) {
      values = data[i][property] as unknown[];
      break;
    }
  }
  return values;
}

export function getGroupedValues(
  data: Record<string, unknown>[],
  keys: unknown[],
  keyProperty: string,
  valueProperty: string,
) {
  const groupedData: Record<string, Record<string, unknown>[]> = {};
  for (let i = 0; i < data.length; i++) {
    const key = data[i][keyProperty] as string;
    if (keys.includes(key)) {
      if (!groupedData[key]) {
        groupedData[key] = [];
      }
      groupedData[key].push(data[i]);
    }
  }
  return groupedData[valueProperty] || [];
}

export function filterData(
  data: Record<string, unknown>[],
  conditionKey: string,
  conditionValue: unknown,
) {
  const filteredData: Record<string, unknown>[] = [];
  for (let i = 0; i < data.length; i++) {
    if (data[i][conditionKey] === conditionValue) {
      filteredData.push(data[i]);
    }
  }
  return filteredData;
}

export function groupByActivityCategory(
  weekData: Record<string, unknown>[],
  property: string,
) {
  const category: Record<string, Record<string, unknown>[]> = {};

  for (let i = 0; i < weekData.length; i++) {
    const activityCategory = weekData[i][property] as string;
    if (!category[activityCategory]) {
      category[activityCategory] = [];
    }
    category[activityCategory].push(weekData[i]);
  }

  return category;
}

export function getColumns(
  groupedData: Record<string, Record<string, unknown>[]>,
) {
  const headers = new Set<string>();
  const columns: { title: string; dataIndex: string; key: string }[] = [];

  for (const property in groupedData) {
    Object.keys(groupedData[property][0]).forEach((header) =>
      headers.add(header),
    );
  }

  headers.forEach((header) => {
    columns.push({
      title: header,
      dataIndex: header,
      key: header,
    });
  });

  return columns;
}

export function getDataTable(
  groupedData: Record<string, Record<string, unknown>[]>,
  type: string,
) {
  let data: Record<string, unknown>[] = [];
  for (const property in groupedData) {
    if (property === type) {
      data = groupedData[property];
      return data;
    }
  }
}

export function getTableDataForActivityCategory(
  groupedData: Record<string, unknown>[],
  subjectId: string,
  columnName: string,
  categoryName: string,
) {
  //Get the values of the data grouped by a single subject. Ex."101-001"
  const subjectValues = getValuesByProperty(groupedData, subjectId) as Record<
    string,
    unknown
  >[];

  //Get data for the specific week. Ex. "Day 1"
  const weekData = filterData(subjectValues, "timepoint", columnName);

  //Group the data with "ACTIVITY_TYPE" as keys and the corresponding object data as values
  const dataGroupedByActivityCategory = groupByActivityCategory(
    weekData,
    "activity_type",
  );

  //Get the table data for the specific activity category. Ex. "QUESTIONNAIRE"
  const activityCategoryData = getDataTable(
    dataGroupedByActivityCategory,
    categoryName,
  );

  return activityCategoryData;
}

//Function to get the last key of the cell data which correspond to the visit type name
export function getLastKeyValue(data: Record<string, unknown>) {
  const keys = Object.keys(data);
  const lastKey = keys[keys.length - 1];
  return { key: lastKey, value: data[lastKey] };
}

//Function that returns a string with the first letter of each word capitalized
export function toTitleCase(str: string) {
  return str
    .replace(/_/g, " ") //replace underscores with spaces
    .toLowerCase()
    .split(" ")
    .map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
}

//Function to filter the other table data based on the common filter key
export function filterOtherTableData(
  currentFilteredData: Record<string, unknown>[],
  originalTargetData: Record<string, unknown>[],
) {
  //Filter the other table data based on the common key
  //IMPORTANT: Change the key "subject" to the key that is common between the two data sets
  const otherTableFilteredData: Record<string, unknown>[] = [];
  for (let i = 0; i < currentFilteredData.length; i++) {
    for (let j = 0; j < originalTargetData.length; j++) {
      if (originalTargetData[j].subject === currentFilteredData[i].subject) {
        otherTableFilteredData.push(originalTargetData[j]);
      }
    }
  }
  return otherTableFilteredData;
}

//Function that returns true if all the filters are empty
export function checkFiltersAreEmpty(
  filters: Record<string, unknown[] | null>,
) {
  //Check if all the filters in the object are null
  if (Object.keys(filters)?.length === 0) {
    return true;
  }
  return Object.keys(filters).every(
    (key) => filters[key] === null || (filters[key] as unknown[])?.length === 0,
  );
}

//Function to create new filters based on the filters of the other table
export function createNewFilters(
  targetData: Record<string, unknown>[],
  currentFilters: Record<string, unknown[] | null>,
) {
  // Create new filters as equivalent to the filters of the other table
  const newFilters = { ...currentFilters }; // copy currentFilters

  // Iterate over all keys in currentFilters
  Object.keys(currentFilters).forEach((key) => {
    if (currentFilters[key] !== null) {
      // Extract the unique values of the target key from the data array
      const newValues = [...new Set(targetData.map((item) => item[key]))];
      // Replace the value of the target key in newFilters
      newFilters[key] = newValues;
    }
  });

  return newFilters;
}
